import { Navigate, createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import type { NotifTab } from "@/features/notifications";
import { NotificationsPage } from "@/features/notifications";
import { hasPermission, useAuth } from "@/shared/auth";

type NotifSearchParams = { tab?: NotifTab };

function parseTabSearch(raw: Record<string, unknown>): NotifSearchParams {
  if (raw.tab === "settings") return { tab: "settings" };
  if (raw.tab === "inbox") return { tab: "inbox" };
  if (raw.tab === "delivery") return { tab: "delivery" };
  return {};
}

function NotificationsRoute(): JSX.Element {
  const { user } = useAuth();
  const { tab } = Route.useSearch();
  // Direct-URL guard: users without read access are sent to their default landing.
  if (!hasPermission(user, "notifications:read")) {
    return <Navigate to="/" />;
  }
  return <NotificationsPage initialTab={tab} />;
}

export const Route = createFileRoute("/_authenticated/notifications")({
  validateSearch: (search): NotifSearchParams => parseTabSearch(search as Record<string, unknown>),
  component: NotificationsRoute,
});
